import React from "react";
import { useTheme } from "@mui/material/styles";
import MessageOutlineIcon from "@iconify/icons-mdi/message-outline";
import MessageTextIcon from "@iconify/icons-mdi/message-text";
import { InlineIcon } from "@iconify/react";
import { useMyTimeMessagesList } from "my-time/hooks";

interface MyTimeMessagesIndicatorProps {
  row: { _id: string };
}

export const MyTimeMessagesIndicator = ({
  row,
}: MyTimeMessagesIndicatorProps) => {
  const theme = useTheme();

  const { data: messages } = useMyTimeMessagesList({ request: row._id });

  return (
    <InlineIcon
      width="20px"
      height="20px"
      icon={messages?.length > 0 ? MessageTextIcon : MessageOutlineIcon}
      style={{
        color: theme.palette.gray60.main,
      }}
    />
  );
};

export default MyTimeMessagesIndicator;
